import React from 'react';
import { Recycle, Cpu, Zap, Leaf, Droplets } from 'lucide-react';
export function SolutionSection() {
  const features = [{
    icon: Recycle,
    title: 'Waste Conversion',
    description: 'Converts municipal and agricultural waste into usable energy resources.'
  }, {
    icon: Cpu,
    title: 'AI Optimization',
    description: 'Proprietary algorithms increase digester efficiency to 85%+.'
  }, {
    icon: Leaf,
    title: 'Emissions Reduction',
    description: 'Significantly reduces landfill waste and harmful methane emissions.'
  }, {
    icon: Zap,
    title: 'Renewable Electricity',
    description: 'Generates baseload renewable electricity at utility scale.'
  }, {
    icon: Droplets,
    title: 'Valuable Byproducts',
    description: 'Produces high-quality bio-fertilizer for agricultural use.'
  }];
  return <section id="solution" className="py-20 lg:py-32 bg-slate-900 relative overflow-hidden" data-id="element-252">
      {/* Background image */}
      <div className="absolute inset-0 z-0" data-id="element-253">
        <img src="https://cdn.magicpatterns.com/uploads/eGNsqEGwCLD5jKpVkFcnqx/AI2Bin2BAD2Bplant.webp" alt="AI bio-digester facility" className="w-full h-full object-cover opacity-5" data-id="element-254" />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900 via-slate-900/95 to-slate-900" data-id="element-255"></div>
      </div>

      {/* Background elements */}
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-emerald-900/10 rounded-full blur-[100px] pointer-events-none" data-id="element-256"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-257">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-258">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-259">
            A Circular Energy Solution
          </h2>
          <p className="text-xl text-slate-300" data-id="element-260">
            Green Fuel uses AI-optimized bio-digesters to convert waste methane
            (CH4) into clean electricity and hydrogen, creating a closed-loop
            system that benefits cities and the planet.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-261">
          {/* Process Diagram - Replace circular animation with infographic */}
          <div className="lg:col-span-5 relative" data-id="element-262">
            <div className="relative rounded-2xl overflow-hidden border border-emerald-500/30 shadow-[0_0_40px_rgba(16,185,129,0.15)] bg-slate-950" data-id="element-263">
              <img src="https://cdn.magicpatterns.com/uploads/5YR7YmtX13SFUFtUPiGmr2/Methane_Conversion.png" alt="Green Fuel methane conversion process" className="w-full h-auto" data-id="element-264" />
            </div>
            <p className="text-center text-sm text-slate-400 mt-4 font-medium" data-id="element-265">
              Complete waste-to-energy conversion process
            </p>
          </div>

          {/* Features List */}
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-266">
            {features.map((feature, index) => {
            const Icon = feature.icon;
            return <div key={index} className={`p-6 rounded-2xl bg-slate-950/50 border border-slate-800 hover:border-emerald-500/30 transition-all duration-300 hover:-translate-y-1 ${index === features.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-267">
                  <div className="w-10 h-10 rounded-lg bg-emerald-500/10 flex items-center justify-center mb-4" data-id="element-268">
                    <Icon className="w-5 h-5 text-emerald-400" data-id="element-269" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-270">
                    {feature.title}
                  </h3>
                  <p className="text-slate-400 text-sm leading-relaxed" data-id="element-271">
                    {feature.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}